import { ReactNode } from 'react';
import { useLogger } from '@packages/shared/core/common/hooks';
import { useQuizStep } from '@packages/shared/core/quiz/hooks';
import { QuizScreenProps, SingleAnswerV2StepData } from '@packages/shared/core/quiz/entities';

type SingleAnswerV2QuizStepProps = {
  id: string;
  renderQuizScreen: (stepData: QuizScreenProps) => ReactNode;
};

const SingleAnswerV2QuizStep = ({ id, renderQuizScreen }: SingleAnswerV2QuizStepProps) => {
  const logger = useLogger();
  const { back, next, stepData, updateUserPreferences, totalSteps, stepOrder } = useQuizStep(id);

  if (!stepData) {
    // TODO add fallback
    logger.error(new TypeError(`Data for ${id} step not found`));
    return null;
  }

  const { dataKey } = stepData as SingleAnswerV2StepData;

  const goBack = async () => back();

  const onChosen = async (text: string, key?: string) => {
    updateUserPreferences(dataKey, text.toLowerCase());
    await next(text, key);
  };

  return (
    <>
      {renderQuizScreen({
        onChosen,
        onBack: goBack,
        totalSteps,
        stepOrder,
        ...(stepData as SingleAnswerV2StepData),
      })}
    </>
  );
};

export default SingleAnswerV2QuizStep;
